import { render, staticRenderFns } from "./field-input.vue?vue&type=template&id=c8a2ba2a&scoped=true&"
import script from "./field-input.vue?vue&type=script&lang=js&"
export * from "./field-input.vue?vue&type=script&lang=js&"
import style0 from "./field-input.vue?vue&type=style&index=0&id=c8a2ba2a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a2ba2a",
  null
  
)

export default component.exports